export default __webpack_public_path__ + "static/media/damage_buildings.264386dc.svg";